export default "__VITE_ASSET__Bqqi43Ry__"